/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomPercentileCalculationMethodCode {
    NORMAL_DISTRIBUTION = 'NORMAL_DISTRIBUTION',
    LOG_NORMAL_DISTRIBUTION = 'LOG_NORMAL_DISTRIBUTION',
    AVERAGE_OF_TWO_PCTS = 'AVERAGE_OF_TWO_PCTS',
    ADJUSTED_PCT = 'ADJUSTED_PCT',
}
